
import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p373487986422038528',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})

